import { Ward } from "./Ward";

export class District {
  constructor(name, code, codename, divisionType, shortCodename, wards) {
    this.name = name;
    this.code = code;
    this.codename = codename;
    this.divisionType = divisionType;
    this.shortCodename = shortCodename;
    this.wards = wards;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new District(
        input.n,
        input.c,
        input.cn,
        input.dt,
        input.sc,
        Ward.fromApiArray(input.w),
      )
    }
    return new District();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => District.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [District.fromApiObject(input)];
    }

    return [];
  }

  static getDistrict(listDistrict = [], value, key = "name") {
    if (!listDistrict || listDistrict.length === 0) {
      return {};
    }
    let result = listDistrict.find(item => item[key].toLowerCase() === String(value).toLowerCase());
    return result || {};
  }
}